import { render, staticRenderFns } from "./SubstituicaoPrestadoresAgiFiltro.vue?vue&type=template&id=8803f7a4"
import script from "./SubstituicaoPrestadoresAgiFiltro.vue?vue&type=script&lang=js"
export * from "./SubstituicaoPrestadoresAgiFiltro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports